import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { editProgramRequest } from "../../../store/Programs/actions";
import PropTypes from "prop-types";
import { ErrorMessage, Form, Formik } from "formik";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import DatePicker from "../../../components/DatePicker";
import { validationEditProgramSchema } from "../ProgramForm/validation";
import moment from "moment";
import styles from "../ProgramForm/ProgramForm.module.scss";
import Upload from "../../../components/Upload";
import CancelIcon from "@mui/icons-material/Cancel";
import { showHideLoader } from "../../../store/Loader/actions";
import { uploadToS3 } from "../../../utils/S3";
import { getLocalORPublicSrc } from "../../../utils/Constants";
import Switch from "../../../components/Switch";

function EditProgram({ id, selectedProgram }) {
  const logoRef = useRef();
  const [previewImage, setPreviewImage] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedProgram?.photo_url && !previewImage) {
      setPreviewImage(selectedProgram.photo_url);
    }
  }, [selectedProgram]);
  async function handleUpdateLimitOfStudents(values) {
    try {
      const submissionValues = {
        ...values,
        start_date: moment(values.start_date).format("DD-MM-YYYY")
      };

      if (submissionValues?.photo_url instanceof File) {
        dispatch(showHideLoader(true));
        const { link } = await uploadToS3(
          "public",
          submissionValues?.photo_url,
          submissionValues?.photo_url.name
        );
        submissionValues.photo_url = link;
      }
      dispatch(editProgramRequest({ id, program: submissionValues }));
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  }

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2-content"
        id="panel2-header"
      >
        Edit Program Form
      </AccordionSummary>
      <AccordionDetails>
        <Formik
          enableReinitialize
          onSubmit={handleUpdateLimitOfStudents}
          // validationSchema={validationEditProgramSchema}
          validationSchema={() =>
            validationEditProgramSchema({
              initialStartDate: selectedProgram?.start_date
            })
          }
          initialValues={{
            photo_url: selectedProgram?.photo_url || "",
            name: selectedProgram?.name || "",
            total_users_limit:
              selectedProgram?.total_users_limit || "",
            start_date: selectedProgram?.start_date,
            end_date: selectedProgram?.end_date,
            book_threads_enabled:
              selectedProgram?.book_threads_enabled || false
          }}
          validateOnBlur={true}
        >
          {({ setFieldValue }) => (
            <Form style={{ width: "400px", margin: "auto" }}>
              <div
                className={styles.upload_container}
                style={{
                  display: previewImage ? "flex" : "block"
                }}
              >
                <Upload
                  ref={logoRef}
                  isMultiple={false}
                  isImage={true}
                  setFieldValue={setFieldValue}
                  label="Upload Logo"
                  name="photo_url"
                  accept="image/*"
                  handlePreviewSrc={setPreviewImage}
                />
                {previewImage ? (
                  <div className={styles.logo_preview}>
                    <CancelIcon
                      onClick={() => {
                        setFieldValue("photo_url", "");
                        setPreviewImage(null);
                        if (logoRef.current)
                          logoRef.current.value = "";
                      }}
                      className={styles.delete_icon}
                    />
                    <img
                      src={getLocalORPublicSrc(previewImage)}
                      alt="logo"
                    />
                  </div>
                ) : null}
                <div></div>
              </div>

              <Input
                type="text"
                name="name"
                label="name"
                isRequired={true}
              />
              <Input
                name="total_users_limit"
                type={"number"}
                isNumber={true}
                isRequired={true}
                label={"Limit of students"}
              />
              <div style={{ margin: "0px 0px 18px 0px" }}>
                <DatePicker
                  format="dd-MM-yyyy"
                  placeholder={"start date"}
                  setFieldValue={setFieldValue}
                  name="start_date"
                />
                <ErrorMessage
                  component="div"
                  className="error-msg"
                  name={"start_date"}
                />
              </div>
              <div style={{ margin: "0px 0px 18px 0px" }}>
                <DatePicker
                  format="dd-MM-yyyy"
                  placeholder={"start date"}
                  setFieldValue={setFieldValue}
                  name="end_date"
                />
                <ErrorMessage
                  component="div"
                  className="error-msg"
                  name={"end_date"}
                />
              </div>
              <Switch
                name="book_threads_enabled"
                label={"book threads enabled"}
              />
              <Button
                text="submit"
                type={"submit"}
                style={{
                  display: "flex",
                  justifySelf: "flex-end"
                }}
              />
            </Form>
          )}
        </Formik>
      </AccordionDetails>
    </Accordion>
  );
}

EditProgram.propTypes = {
  id: PropTypes.string,
  selectedProgram: PropTypes.object
};

export default EditProgram;
